var Handlebars = require("handlebars/runtime");
module.exports = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "<div id=\"modal-cnt\" class=\"app-modal-cnt\"></div>\n<div id=\"modal2-cnt\"></div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "        "
    + container.escapeExpression((helpers.view || (depth0 && depth0.view) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),require("./../CookieBannerView/CookieBannerView"),{"name":"view","hash":{},"data":data}))
    + "\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3=container.escapeExpression;

  return alias3((helpers.view || (depth0 && depth0.view) || alias2).call(alias1,require("./../NavigationBarView/NavigationBarView"),{"name":"view","hash":{"model":(depth0 != null ? depth0.model : depth0)},"data":data}))
    + "\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isDemoModeOff : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "<div id=\"app-cnt\">\n    <div class=\"app-loader\">"
    + alias3((helpers.include || (depth0 && depth0.include) || alias2).call(alias1,require("./../AppLoader/AppLoader.hbs"),{"name":"include","hash":{},"data":data}))
    + "</div>\n</div>\n"
    + alias3((helpers.view || (depth0 && depth0.view) || alias2).call(alias1,require("./../EmailVerificationBannerView/EmailVerificationBannerView"),{"name":"view","hash":{"model":(depth0 != null ? depth0.model : depth0)},"data":data}))
    + "\n<div id=\"notification-cnt\"></div>\n<div id=\"cookie-banner\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showCookieBanner : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n<div id=\"rotation-cnt\">\n    <h2 class=\"sg-font-color--dark-grey\">"
    + alias3((helpers.t || (depth0 && depth0.t) || alias2).call(alias1,"BASIC_LAYOUT.ROTATE",{"name":"t","hash":{},"data":data}))
    + "</h2>\n</div>\n<div id=\"staging-cnt\"></div>";
},"useData":true});



//////////////////
// WEBPACK FOOTER
// ./shared/view/BasicLayout/BasicLayout.hbs
// module id = 643
// module chunks = 46 47